import apiClient from 'utilities/api-client';
import { SILServiceDetailsResponse } from '@good/schemas';

export const fetchServiceAgreementService = async (request: { serviceAgreementServiceId: string }) =>
  await apiClient
    .get(`api/portal/customers/service-agreements-service/${request.serviceAgreementServiceId}`)
    .then((response) => ({ ...response, data: SILServiceDetailsResponse.parse(response.data) }));
